import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Tab } from 'semantic-ui-react';

const { Pane } = Tab;

const RegistriesPane = () =>
    <Pane attached={false}>
        <h2>Widget do przeglądania rejestrów przygotowany przez MADKOM SA</h2>
        <h3>Instrukcja instalacji widgetu</h3>
        <p>Aby używać widgetu potrzebna jest biblioteka JQuery. Musimy także dołączyć odpowiedni skrypt na stronie:</p>
        <ul>
            <li>http://api.madkom.pl/registries-widget.js - kod js widgetu (wymagany)</li>
            <li>http://api.madkom.pl/registries-widget.css - podstawowe style (plik ten nie jest wymagany i można samemu ostylować widget od podstaw)</li>
        </ul>
        <p>Aby uruchomić widget należy posiadać identyfikator organizacji i wywołać poniższy kod:</p>
        <SyntaxHighlighter
            language="javascript"
            showLineNumbers>
            {`$('selektor-elementu-w-ktorym-chcemy-osadzic-widget').ezdRegistries({organizationId: 'id-organizacji', perPage: 'liczba rejestrow na stronie (domyślnie 10)'});`.toString()}
        </SyntaxHighlighter>
        <h3>Przykłady</h3>
        <p>Czysty widget z domyślnymi stylami <a href="http://api.madkom.pl/examples/registries-default.html" target="__blank">online</a>:</p>
        <SyntaxHighlighter
            language="html"
            showLineNumbers>
            {`<html>
    <head lang="en">
        <meta charset="UTF-8">
        <title></title>
        <script type="text/javascript" src="https://code.jquery.com/jquery-2.1.4.js"></script>
        <script type="text/javascript" src="http://api.madkom.pl/widget-registries.js"></script>
        <link rel="stylesheet" type="text/css" href="http://api.madkom.pl/widget-registries.css" />
        <script>
            $(document).ready(function(){
                $('#widget-1').ezdRegistries({organizationId: 1, perPage: 5});
            });
        </script>
    </head>
    <body>
        <div id="widget-1"></div>
    </body>
</html>`.toString()}
        </SyntaxHighlighter>
        <p>Przykład z nadpisanymi stylami <a href="http://api.madkom.pl/examples/registries-custom.html" target="__blank">online</a>:</p>
        <SyntaxHighlighter
            language="html"
            showLineNumbers>
            {`<html>
<head lang="en">
    <meta charset="UTF-8">
    <title></title>
    <script src="https://code.jquery.com/jquery-2.1.4.js" type="text/javascript"></script>
    <script src="http://127.0.0.1/statusysprawfrontend/widget-registries.js" type="text/javascript"></script>
    <link href="http://fonts.googleapis.com/css?family=Roboto:400,900,900italic,700italic,700,500italic,500,400italic,300italic,100,100italic,300&amp;subset=latin,latin-ext" rel="stylesheet" type="text/css">
    <style>
        body{font-family:Roboto;background-color:#e0e0e0}
        div#widget-registries{box-shadow:rgba(70,70,70,.2) 0 2px 0 0;background-color:#fff;padding:2em}
        div#widget-registries ol{list-style-type:none;padding-left:10px}
        a.show-registry-list,div#widget-registries ol li a,div.madkom-registry-paging a{text-decoration:none;color:#121212;font-weight:700}
        a.show-registry-list:hover,div#widget-registries ol li a:hover,div.madkom-registry-paging a:hover{color:grey}
        a.show-registry-list:before{content:"<< "}
        form.madkom-registry-form label{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}
        form.madkom-registry-form input{padding:.5em;margin-top:.5em;margin-right:.5em;width:25%;font-size:16px;color:#df815a}
        form.madkom-registry-form button{-webkit-border-radius:10px;-moz-border-radius:10px;-ms-border-radius:10px;-o-border-radius:10px;border-radius:10px;border:none;font-size:16px;color:#fff;cursor:pointer;-webkit-transition:all .6s ease;-moz-transition:all .6s ease;-ms-transition:all .6s ease;-o-transition:all .6s ease;transition:all .6s ease;padding:.5em;opacity:.8;margin-right:.5em}
        form.madkom-registry-form button:hover{box-shadow:rgba(70,70,70,.2) 0 2px 0 0;opacity:1}
        form.madkom-registry-form button[type=submit]{background-color:#7dbf94}
        form.madkom-registry-form button[type=reset]{background-color:#df815a}
        table.madkom-registry-table{width:100%;border-collapse:collapse;border-spacing:0;margin:.5em 0}
        table.madkom-registry-table td,table.madkom-registry-table th{border:1px solid #ddd;border-spacing:0;padding:3px}
        div.madkom-registry-paging>a,div.madkom-registry-paging>em,div.madkom-registry-paging>span{display:inline-block;margin:.2em;padding:.2em .5em;border:1px solid #ddd}
        div.madkom-registry-paging>span.disabled{color:#aaa;font-weight:700}
        div.madkom-registry-paging>span.current{background-color:#df815a;font-weight:700}
        div.madkom-registry-paging{text-align:center}
        div.madkom-registry-loader{width:100%;height:100px;text-align:center;vertical-align:bottom;line-height:100px}
    </style>
    <script>
        $(document).ready(function() {
            $("#widget-registries").ezdRegistries({organizationId: 1, perPage: 3});
        });
    </script>
</head>
<body>
<div id="widget-registries"></div>
</body>
</html>`.toString()}
        </SyntaxHighlighter>
    </Pane>

export default RegistriesPane;


// WEBPACK FOOTER //
// ./src/containers/widget/components/RegistriesPane.js